import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  getFootermenu,
  getLocationSmartTags,
  fetchPlaylist,
  getUser,
} from './../actions';
import {
  fetchFooterStaticText,
  getSections,
  fetchFeeds,
} from './../../ui/src/actions.js';
import { Header } from './../component/header';
import { Loader } from '../../ui/src/component/loader';

import Footer from '../component/footer';
import Banner from '../component/banner';

import SweetAlert from 'sweetalert-react';
import Api from '../../ui/src/api.js';
import Cookies from 'js-cookie';
import Helmet from 'react-helmet';
import { getProp } from '../../ui/src/utilities';
import HeaderPanel from '../../ui/src/component/headerPanel';

// Moment locale initialisation
import 'moment/locale/sk';
import CookieConsent from '../../ui/src/component/cookies/cookieConsent';

class App extends React.Component {
  constructor(props) {
    super(props);

    const feeds = [];
    const feedsObj = getProp(this.props, 'feeds', {});
    for (const k in feedsObj) {
      feeds.push(feedsObj[k]);
    }

    this.state = {
      searchQuery: getProp(this.props, 'location.query.q', ''),
      namedays: null,
      currentFeed: feeds.length > 0 ? feeds[0] : null,
    };

    this.playlistInterval = null;
    this.feedChangeInterval = null;

    this.changeFeed = this.changeFeed.bind(this);
  }

  onSubmitSearch() {
    let q = this.state.searchQuery.trim();
    if (q.length > 0) {
      this.props.dispatch(push(`/vyhladavanie?q=${q}`));
    }
  }

  changeFeed() {
    const { currentFeed } = this.state;
    const feeds = Object.values(this.props.feeds);
    let nextFeed = null;
    if (currentFeed !== null) {
      for (let i = 0; i < feeds.length; i++) {
        if (currentFeed._id === feeds[i]._id) {
          if (i + 1 === feeds.length) {
            nextFeed = feeds[0];
            break;
          } else {
            nextFeed = feeds[i + 1];
            break;
          }
        }
      }
    } else {
      nextFeed = feeds[0];
    }
    this.setState({
      currentFeed: nextFeed,
    });
  }

  componentDidMount() {
    App.fetchDataHelper(this.props.dispatch).catch(() => {});
    this.feedChangeInterval = setInterval(this.changeFeed, 10000);

    this.playlistInterval = setInterval(() => {
      this.props.dispatch(fetchPlaylist());
    }, 30000);

    // Log user, if redirected from login
    let response = Api.paramsToObject(getProp(this.props, 'location.hash'));
    let token = getProp(response, 'access_token');
    if (token) {
      Cookies.set('token', token);
      window.location.href = '';
    }
    // If we have token stored
    token = Cookies.get('token');
    if (token) {
      this.props.dispatch(getUser(token));
    }
  }

  componenWillDismount() {
    clearInterval(this.playlistInterval);
    clearInterval(this.feedChangeInterval);
  }

  componentDidUpdate(prevProps) {
    if (
      Object.keys(this.props.feeds).length > 0 &&
      Object.keys(prevProps.feeds).length === 0
    ) {
      this.changeFeed();
    }
  }

  render() {
    return (
      <div>
        <Helmet title="Hlavná stránka" titleTemplate="%s | Košice Online" />
        <CookieConsent />
        <Loader loading={this.props.loading} />
        <HeaderPanel feed={this.state.currentFeed} />
        <div>
          <div className="container">
            <Banner
              id="banner-kosiceonline-sk-uplne-na-vrchu"
              autoReload={true}
              location={this.props.location}
            />
          </div>
        </div>
        <Header
          unreadArticles={this.props.unreadArticles}
          nav={this.props.categories}
          seasonnav={this.props.seasonmenu}
          smarttags={this.props.locationSmartTags}
          searchQuery={this.state.searchQuery}
          onChangeSearchQuery={(searchQuery) => this.setState({ searchQuery })}
          onSubmitSearch={this.onSubmitSearch.bind(this)}
          namedays={this.state.namedays}
          currentSong={
            this.props.playlist && this.props.playlist[0]
              ? this.props.playlist[0].title
              : ''
          }
          loggedUser={this.props.user}
        />
        <div>
          <div className="container">
            <Banner
              id="banner-kosiceonline-sk-medzi-menu-a-obsah-stranky"
              location={this.props.location}
            />
          </div>
        </div>
        <div>
          <div>{this.props.children}</div>
          <SweetAlert
            title=""
            {...this.props.alert}
            show={this.props.alert !== null}
          />
        </div>
        <Footer
          nav={this.props.footermenu}
          content={this.props.footerStaticText}
          copyrightText={`2017-${new Date().getFullYear()} \xA9 MARK MEDIA s.r.o.`}
        />
      </div>
    );
  }
}

App.fetchDataHelper = (dispatch) => {
  return Promise.all([
    dispatch(fetchPlaylist()),
    dispatch(
      getSections(
        process.env.REACT_APP_CONTENT_SPACE,
        'CATEGORIES',
        'categories',
      ),
    ),
    dispatch(
      getSections(
        process.env.REACT_APP_CONTENT_SPACE,
        'SEASONMENU',
        'seasonmenu',
      ),
    ),
    dispatch(getLocationSmartTags()),
    dispatch(getFootermenu()),
    dispatch(
      fetchFooterStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'text-v-pate-stranky',
      ),
    ),
    dispatch(fetchFeeds()),
  ]);
};

App.fetchData = ({ store }) => {
  return App.fetchDataHelper(store.dispatch);
};

App.__name = 'App';

App.propTypes = {
  alert: PropTypes.object,
  loading: PropTypes.number.isRequired,
  footermenu: PropTypes.array.isRequired,
  seasonmenu: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  footerStaticText: PropTypes.object,
  locationSmartTags: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  playlist: PropTypes.array.isRequired,
  user: PropTypes.object,
  unreadArticles: PropTypes.number,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    alert: state.alert,
    loading: state.loading,
    footermenu: state.footermenu.data.sections,
    footerStaticText: state.footerStaticText.data.content,
    locationSmartTags: state.locationSmartTags.data.values,
    categories: state.categories.data.sections,
    seasonmenu: state.seasonmenu.data.sections,
    playlist: state.playlist.data.items,
    user: state.loggedUser.user,
    unreadArticles: state.loggedUser.unreadArticles,
    feeds: state.feeds.byId,
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/app/container/app.js